import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountLocatorRuleInvocation  {
    _originalTypeClassName = "zERP.BO.AccountLocatorRuleInvocation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountLocatorRuleInvocation.translate = translateService;
}
this.Rule = new Domain.AccountLocatorRule();
this.Inputs = [];
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Rule:any;
Inputs:any;
static setRule = ($this, value) => {
var oldValue = $this.Rule;
$this.Rule = value;
if (value != null) {
}
}
static setInputs = ($this, items) => {
                if (items == null) items = [];
                if ($this.Inputs == null) $this.Inputs = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Inputs.length > 0) {
                    Domain.AccountLocatorRuleInvocation.removeInputs($this, $this.Inputs[0]);
                }

                Domain.AccountLocatorRuleInvocation.addManyInputs($this, copyItems);
            }
static addManyInputs = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountLocatorRuleInvocation.addInputs($this, items[i]);
                }
            }
static addInputs = ($this, item) => {
                if ($this.Inputs == null) $this.Inputs = [];
                if (item == null || $this.Inputs.indexOf(item) > -1) return;
                $this.Inputs.push(item);
}
static addRangeInputs = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountLocatorRuleInvocation.addInputs($this, item));
            }
static removeInputs = ($this, item) => {
                if ($this == null || $this.Inputs == null || $this.Inputs.indexOf(item) === -1) return;
                var _index = $this.Inputs.indexOf(item);
                $this.Inputs.splice(_index, 1);
}
static clearInputs = ($this) => { $this.Inputs = null; }

static FillInputs($this: any): any{if ($this?.Inputs == null) {Domain.AccountLocatorRuleInvocation.setInputs($this, []);}
for (let _iinp = 0; _iinp < ($this?.Rule?.Context == null ? 0 : $this?.Rule?.Context.length); _iinp++) {let inp = $this?.Rule?.Context[_iinp];let existing = $this?.Inputs?.linq?.where((i) => i?.Name == inp?.Name)?.firstOrDefault(null);if (existing == null) {existing = new Domain.AccountLocatorRuleInvocationInput();existing.Name = inp?.Name;$this?.Inputs?.add(existing);}Domain.AccountLocatorRuleInvocationInput.setEntity(existing, inp?.Entity);}
let toRemove = [];
for (let _iinp = 0; _iinp < ($this?.Inputs == null ? 0 : $this?.Inputs.length); _iinp++) {let inp = $this?.Inputs[_iinp];if (!($this?.Rule?.Context?.linq?.any((i) => i?.Name == inp?.Name))) {toRemove?.add(inp);}}
while (toRemove?.linq?.any()) {let dl = toRemove?.linq?.where()?.firstOrDefault(null);toRemove?.splice(toRemove.indexOf(dl), 1);$this?.Inputs?.splice($this?.Inputs.indexOf(dl), 1);}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}